<div class="main">
    <div class="dx-field-title" translate>environmentAdmins.pageTitle</div>
    <div class="dx-fieldset" style="height:95%;">
        <dx-data-grid #adminsGrid
                      [dataSource]="admins"
                      keyExpr="user.id"
                      [showRowLines]="true"
                      [columnAutoWidth]="true"
                      [focusedRowEnabled]="true"
                      height="calc(100vh - 150px)"
                      hoverStateEnabled="true"
                      (onEditorPreparing)="onEditorPreparing($event)"
                      (onContextMenuPreparing)="onContextMenuPreparing($event)"
                      (onRowDblClick)="onRowDblClick($event)">
            <dxo-search-panel [width]="250" [visible]="true" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
            <dxo-header-filter></dxo-header-filter>
            <dxo-paging enabled="false"></dxo-paging>
            <dxo-summary>
                <dxi-total-item column="user.properties.displayName" [displayFormat]="'_commons.adminsCount' | translate" summaryType="count"></dxi-total-item>
            </dxo-summary>
            <dxo-toolbar>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="showCreatePopup()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadData()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>

            <!-- DataGrid columns -->
            <dxi-column [width]="100" dataField="user.photo" caption="" [allowSorting]="false" cellTemplate="pictureCellTemplate"></dxi-column>
            <dxi-column dataField="user.properties.displayName" [caption]="'_commons.name' | translate"></dxi-column>
            <dxi-column dataField="user.name" [caption]="'_commons.email' | translate" cellTemplate="mailCellTemplate"></dxi-column>

            <!-- Custom cell templates -->
            <div *dxTemplate="let cell of 'mailCellTemplate'">
                <a href="mailto:{{cell.data.user.name}}">{{cell.data.user.name}}</a>
            </div>
            <div *dxTemplate="let cell of 'pictureCellTemplate'">
                <img class="img" [src]="cell.data.user.photo" width="48" height="48" [alt]="cell.data.user.name" />
            </div>
        </dx-data-grid>
    </div>
</div>

<!-- Create popup -->
<dx-popup [title]="'environmentAdmins.popupCreateTitle' | translate" [(visible)]="createPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical">
            <dx-validation-group #envAdminValidationGroup>
                <div class="dx-field">
                    <div class="dx-field-label" translate>
                        _commons.employee<span class="dx-field-item-required-mark">
                            *
                        </span>
                    </div>
                    <div class="dx-field-value">
                        <app-employee-picker [(selectedItem)]="newAdmin.user" [isRequired]="true"></app-employee-picker>
                    </div>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>environmentAdmins.lblManageEnvironment</span>
                    <dx-switch [(value)]="newAdmin.canManageEnvironmentSettings"></dx-switch>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>environmentAdmins.lblManageLocalAgents</span>
                    <dx-switch [(value)]="newAdmin.canManageLocalAgents"></dx-switch>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>environmentAdmins.lblManageFileTransfers</span>
                    <dx-switch [(value)]="newAdmin.canManageFileTransfers"></dx-switch>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>environmentAdmins.lblManageRemotePlatforms</span>
                    <dx-switch [(value)]="newAdmin.canManageRemotePlatforms"></dx-switch>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>environmentAdmins.lblManagePgpKeys</span>
                    <dx-switch [(value)]="newAdmin.canManagePgpKeys"></dx-switch>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>environmentAdmins.lblExecuteTransfers</span>
                    <dx-switch [(value)]="newAdmin.canExecuteTransfers"></dx-switch>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>environmentAdmins.lblDisableAckAlerts</span>
                    <dx-switch [(value)]="newAdmin.canDisableACKAlerts"></dx-switch>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>environmentAdmins.lblAccessLogs</span>
                    <dx-switch [(value)]="newAdmin.canAccessLogs"></dx-switch>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.add' | translate" (onClick)="createAdmin(newAdmin)"></dx-button>
                    <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="this.createPopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Edit popup -->
<dx-popup [title]="'environmentAdmins.popupEditTitle' | translate" [(visible)]="editPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical">
            <div class="dx-field">
                <div class="dx-field-label" translate>_commons.employee</div>
                <div class="dx-field-value">{{editAdmin.user.name}}</div>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>environmentAdmins.lblManageEnvironment</span>
                <dx-switch [(value)]="editAdmin.canManageEnvironmentSettings"></dx-switch>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>environmentAdmins.lblManageLocalAgents</span>
                <dx-switch [(value)]="editAdmin.canManageLocalAgents"></dx-switch>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>environmentAdmins.lblManageFileTransfers</span>
                <dx-switch [(value)]="editAdmin.canManageFileTransfers"></dx-switch>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>environmentAdmins.lblManageRemotePlatforms</span>
                <dx-switch [(value)]="editAdmin.canManageRemotePlatforms"></dx-switch>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>environmentAdmins.lblManagePgpKeys</span>
                <dx-switch [(value)]="editAdmin.canManagePgpKeys"></dx-switch>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>environmentAdmins.lblExecuteTransfers</span>
                <dx-switch [(value)]="editAdmin.canExecuteTransfers"></dx-switch>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>environmentAdmins.lblDisableAckAlerts</span>
                <dx-switch [(value)]="editAdmin.canDisableACKAlerts"></dx-switch>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>environmentAdmins.lblAccessLogs</span>
                <dx-switch [(value)]="editAdmin.canAccessLogs"></dx-switch>
            </div>
            <div class="flex bottom-buttons">
                <dx-button class="save" [text]="'_commons.save' | translate" [disabled]="isCurrentUser$(editAdmin) | async"
                           (onClick)="updateAdmin(editAdmin)"></dx-button>
                <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="this.editPopupVisible = false"></dx-button>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>
